/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-09-06 14:38:55
 * @FilePath: /m-anquan-baidu-com/src/containers/product/compliance.js
 * @Description: 史宾格安全及隐私合规平台
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchPagesDataById, fetchServiceIntroduce, fetchProductId} from '../../actions/productAction';
import {fetchUrlUpload} from '../../actions/fileCheckAction';
import PropTypes from 'prop-types';

class Compliance extends Component {
    static propTypes = {
        bannerInfo: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            cardOff: false
        };
    }

    render() {
        let cardOff = this.state.cardOff;
        const bannerInfo = this.props.bannerInfo || {};
        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>
                <div className={'product-des'}>
                    基于AI能力的安全/隐私问题检测及动态分析平台。帮助您的企业高效、低成本地开展 App 合规问题自查，
                    满足监管要求助力您隐私合规。基于 AI 检测技术，提供隐私风险项检测、隐私专项检测、场景检测、权限过度收集与使用
                    情况检测等产品服务，深度挖掘 App 隐私合规风险产生的源头。
                </div>

                <div className={'compliance-title'}>
                    史宾格安全及隐私合规平台-用科技让合规更简单
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'}/>
                </div>
                <div className={'product-mod'}>
                    <div
                        className={'pro-applicable com-pro'}
                        style={{backgroundImage: `url(${require('../../asset/image/compliance/c1.png')})`}}
                    >
                        <div>
                            <div className={'pro-app-title'}>
                                监管机构
                            </div>
                            <div className={'pro-app-content'}>
                                满足高并发量的检测需求，可迅速发现 App 中的隐私风险问题，最大化降低人力与时间投入成本。
                            </div>
                        </div>

                    </div>
                    <div
                        className={'pro-applicable com-pro'}
                        style={{backgroundImage: `url(${require('../../asset/image/compliance/c2.png')})`}}
                    >
                        <div>
                            <div className={'pro-app-title'}>
                                应用市场
                            </div>
                            <div className={'pro-app-content'}>
                                提供定制化检测接口，与应用市场控制端形成无缝衔接，在不破坏原有运营架构的情况下，精准批量地对应用市场内发布的 App 进行隐私合规检测。
                            </div>
                        </div>
                    </div>
                    <div
                        className={'pro-applicable com-pro'}
                        style={{backgroundImage: `url(${require('../../asset/image/compliance/c3.png')})`}}
                    >
                        <div>
                            <div className={'pro-app-title'}>
                                大型企业
                            </div>
                            <div className={'pro-app-content'}>
                                企业级 App 的隐私风险监控，一站式解决企业 App 矩阵隐私风险治理问题。避免问题产品流向市场，出现舆论或合规风险，为企业的良好口碑和健康发展提供更有力的保障。
                            </div>
                        </div>
                    </div>
                    <div
                        className={'pro-applicable com-pro'}
                        style={{backgroundImage: `url(${require('../../asset/image/compliance/c4.png')})`}}
                    >
                        <div>
                            <div className={'pro-app-title'}>
                                App开发者
                            </div>
                            <div className={'pro-app-content'}>
                                面对极其繁重的检测任务，可自动检测 App 的敏感权限申请和使用的宏观状况，精准定位问题代码位置和问题场景，协助在 App 上架前进行合规风险自查。
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'产品功能'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>隐私专项检测</div>
                            <div className={'profun-box-des'}>
                                以国家颁布并执行的法律法规为检测标准，基于隐私政策文本自动化分析技术，对 App 个人信息收集使用行为
                                进行逐条对应分析，发现问题并针对检测结果给出合规性建议。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>隐私风险项检测</div>
                            <div className={'profun-box-des'}>
                                对 App 违法违规行为进行全自动检测，包含频繁申请权限、个人信息安全传输等行为。
                                经过对输出结果的处理可以对应到具体法规。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>场景检测</div>
                            <div className={'profun-box-des'}>
                                提供对 APP 的隐私政策的合规性检测能力，以及在不同运行环境下敏感行为的发现、代码定位和敏感权限的申请
                                告知场景、使用场景的检测能力，是判断 APP 隐私合规的重要依据。<br/>
                                通过云端手机模拟 APP 的真实使用环境，发现敏感权限下个人信息的行为溯源和个人信息的传输所存在哪些隐私
                                风险问题。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>权限检测</div>
                            <div className={'profun-box-des'}>
                                基于市场最全的第三方 SDK 隐私检测能力和特征库，以及权限到 API 的映射关系数据库，检测 App 申请及
                                使用的敏感权限和集成 SDK 情况。可视化展示权限的代码调用分布，并对 SDK 中调用权限所在的具体代码调
                                用位置进行溯源。同时基于语义分析技术检测输入型个人敏感信息并查看其代码位置。<br/>
                                通过对产品多个不同版本之间的对比分析，帮助产品快速定位隐私合规问题起始版本和原因，更快解决隐私合规
                                问题。利用市场上同类产品的差异性对比，可以从更宏观的视角了解产品的隐私情况，及时发现不必要的隐
                                私合规问题并及早调整。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>安全服务</div>
                            <div className={'profun-box-des'}>
                                应对 App 存在的主流安全风险，采用强大的多引擎扫描系统和漏洞扫描引擎为 App 提供病毒误报检测和漏洞检测服务，
                                以便安心上架。
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'核心优势'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/compliance/icon_jingzhun.svg')}
                                width={'100%'}
                                alt={''}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>精确:领先的检测技术</div>
                            <div className={'proinfo-box-des'}>
                                以先进的人工智能技术为支撑，覆盖产品全生命周期的隐私合规需求，包含隐私数据采集、权限使用场景、隐私
                                政策管理等多重纬度技术检测能力，得出全面精准地合规风险检测结果。
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/compliance/icon_biaozhun.svg')}
                                width={'100%'}
                                alt={''}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>标准:深度贴合国家监管标准</div>
                            <div className={'proinfo-box-des'}>
                                依据国家网信办、工信部、公安部、市场监管总局于2019 年 12 月 30 日联合发布的《App 违法违规收集使用
                                个人信息行为认定方法》，国家标准GB/T35273《信息安全技术 个人信息安全规范》，以及《中华人民共和国
                                网络安全法》、《中华人民共和国消费者权益保护法》等相关国家法律法规，对 App 收集使用用户个人信息的
                                行为逐条对应分析，合规问题一目了然。
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'} style={{borderBottom: 'none', paddingBottom: '0'}}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/compliance/icon_gaoxiao.svg')}
                                width={'100%'}
                                alt={''}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>高效:企业级自动化检测</div>
                            <div className={'proinfo-box-des'}>
                                自动化隐私风险发现和检测，对 App 收集使用个人信息的行为深入分析，替代人工翻查代码，可快速处理大
                                批量App，节约人力成本，显著提升检测效率。
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className={'product-mod'}>
                        <ProductTitle title={'合作伙伴'}/>
                    </div>
                    <div className={'product-mod'}>
                        <img
                            src={require('../../asset/image/compliance/friend.png')}
                            alt="合作伙伴"
                            style={{width: '100%'}}
                        />
                    </div>
                </div>

                <div className={'join-type-mod'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'接入方式'}/>
                    </div>
                    <div className={'join-type'}>
                        <div className="join-type-item zy">
                            企业尊享版&nbsp;
                            <span
                                className="join-type-link"
                                onClick={() => {
                                    this.setState({
                                        cardOff: !cardOff
                                    });
                                }}
                            >
                                立即咨询
                                <svg
                                    className={cardOff ? 'on' : ''}
                                    width=".44rem" height=".44rem" viewBox="0 0 44 44" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <title>icon_fold blue</title>
                                    <desc>Created with Sketch.</desc>
                                    <g id="icon_fold-blue" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="编组-11">
                                            <g id="icon_arrow_blue_normal_24">
                                                <g id="Rectangle-9">
                                                    <rect x="0" y="0" width="44" height="44"></rect>
                                                </g>
                                            </g>
                                            <polygon
                                                id="lj-3" fill="#3388FF" fillRule="nonzero"
                                                points={'34.485551 15.2610112 35.8329865 16.7389888 21.992399 29.3'
                                                + '571092 8.32162654 16.7347173 9.67837346 15.2652827 22.001 26.642'}>
                                            </polygon>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            {
                                cardOff
                                    ? <div className="join-type-item-card">
                                        合作电话：400-805-4999<br/>
                                        工作时间：9:00-20:00
                                    </div>
                                    : null
                            }
                        </div>
                        <div className="join-type-item fc" style={{display: 'none'}}>
                            扶持版&nbsp;
                            <a className="join-type-link" href="/springer/plan" target="_blank">
                                限时申领
                                <svg
                                    width=".44rem" height=".44rem" viewBox="0 0 24 24" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <title>icon_arrow_blue_normal_24</title>
                                    <desc>Created with Sketch.</desc>
                                    <g
                                        id="icon_arrow_blue_normal_24" stroke="none" strokeWidth="1" fill="none"
                                        fillRule="evenodd">
                                        <g>
                                            <rect id="Rectangle-9" x="0" y="0" width="24" height="24"></rect>
                                            <path
                                                d={'M19.618975,11.5 L11.6799078,4.88411064 L12.3200922,4.115889'
                                                + '36 L21.3200922,11.6158894 C21.5599693,11.8157869 21.5599693,1'
                                                + '2.1842131 21.3200922,12.3841106 L12.3200922,19.8841106 L11.679'
                                                + '9078,19.1158894 L19.618975,12.5 L3.95351375,12.5 L3.95351375,'
                                                + '11.5 L19.618975,11.5 Z'}
                                                id="Combined-Shape" fill="#3388FF" fillRule="nonzero"></path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                        <div className="join-type-item fc" style={{display: 'none'}}>
                            企业用户标准版&nbsp;
                            <a className="join-type-link" href="/console/#/SpringerBuy" target="_blank">
                                立即体验
                                <svg
                                    width=".44rem" height=".44rem" viewBox="0 0 24 24" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <title>icon_arrow_blue_normal_24</title>
                                    <desc>Created with Sketch.</desc>
                                    <g
                                        id="icon_arrow_blue_normal_24" stroke="none" strokeWidth="1" fill="none"
                                        fillRule="evenodd">
                                        <g>
                                            <rect id="Rectangle-9" x="0" y="0" width="24" height="24"></rect>
                                            <path
                                                d={'M19.618975,11.5 L11.6799078,4.88411064 L12.3200922,4.115889'
                                                + '36 L21.3200922,11.6158894 C21.5599693,11.8157869 21.5599693,1'
                                                + '2.1842131 21.3200922,12.3841106 L12.3200922,19.8841106 L11.679'
                                                + '9078,19.1158894 L19.618975,12.5 L3.95351375,12.5 L3.95351375,'
                                                + '11.5 L19.618975,11.5 Z'}
                                                id="Combined-Shape" fill="#3388FF" fillRule="nonzero"></path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        pagesDatabyid: state.pagesDatabyid,
        navListIndex: state.navListIndex,
        serviceIntroduce: state.serviceIntroduce
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchUrlUpload: (obj, type) => fetchUrlUpload(dispatch, obj, type),
        fetchPagesDataById: id => fetchPagesDataById(dispatch, id),
        fetchServiceIntroduce: itemid => fetchServiceIntroduce(dispatch, itemid),
        fetchProductId: id => fetchProductId(dispatch, id)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Compliance);



// WEBPACK FOOTER //
// ./src/containers/product/compliance.js